import { ReactComponent as Add } from "@assets/icons/add_icon.svg";

const AddIcon = (props: any): JSX.Element => {
  return (
    <Add
      fill={props?.sx?.color || props?.sx?.fill}
      height={props?.sx?.height || "16px"}
      width={props?.sx?.width || props?.sx?.height || "16px"}
      {...props}
    />
  );
};

export default AddIcon;
